import React, { memo } from 'react'
import { Box } from 'transfix-ui/core'
import { SAFETY_RATING } from 'types/carrier'
import { capitalize } from 'utils/capitalize'
import { FMCSA_STATUS_ICON_MAP } from 'constants/carriers'

interface ISafetyStatusProps {
  status: SAFETY_RATING
}

const SafetyStatus = memo<ISafetyStatusProps>(({ status }) => {
  const { Icon, className, color } = FMCSA_STATUS_ICON_MAP[status]

  return (
    <Box display='flex' alignItems='center' gap='4px' width='max-content'>
      {Icon && <Icon className={`large ${className}`} />}
      <strong className={color}>{capitalize(status)}</strong>
      <span className='text-secondary'>&nbsp;rating on FMCSA</span>
    </Box>
  )
})

export default SafetyStatus
